import React from 'react';
import { Link } from 'react-router-dom';

const PaymentFailed = () => {
  // Inline styles
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(135deg, #f9c2c2, #f1f1f1)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  };

  const contentStyle = {
    textAlign: 'center',
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    maxWidth: '400px',
    width: '100%',
  };

  const errorMessageStyle = {
    color: '#f44336',  // Red color for error message
    fontSize: '2rem',
    marginBottom: '20px',
  };

  const descriptionStyle = {
    fontSize: '1.1rem',
    marginBottom: '20px',
    color: '#555',
  };

  const linkStyle = {
    display: 'inline-block',
    fontSize: '1.1rem',
    padding: '10px 20px',
    textDecoration: 'none',
    backgroundColor: '#007bff',
    color: '#fff',
    borderRadius: '4px',
    transition: 'background-color 0.3s ease',
  };

  const linkHoverStyle = {
    backgroundColor: '#0056b3',
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <h1 style={errorMessageStyle}>Payment Failed</h1>
        <p style={descriptionStyle}>
          Unfortunately, your payment was not successful. Please try again or contact support.
        </p>
        <Link
          to="/"
          style={linkStyle}
          onMouseEnter={(e) => e.target.style.backgroundColor = linkHoverStyle.backgroundColor}
          onMouseLeave={(e) => e.target.style.backgroundColor = linkStyle.backgroundColor}
        >
          Back to Home Page
        </Link>
      </div>
    </div>
  );
}

export default PaymentFailed;
